module.exports = __webpack_public_path__ + "static/media/tag-selected.223e3618.svg";